import { FC } from "react";
import { AdminPatrolSystem } from "../../../../../http/patrol/types/patrolSystems";
import SystemForm from "./SystemForm";

interface PatrolSystemDetailsProps {
  patrolSystem?: AdminPatrolSystem;
  disabled?: boolean;
  isLoading?: boolean;
  onUpdate: (isAnchorPoint: boolean, isLifeLine: boolean, isClampable: boolean) => void;
}

const PatrolSystemDetails: FC<PatrolSystemDetailsProps> = ({
  patrolSystem,
  disabled,
  isLoading,
  onUpdate,
}: PatrolSystemDetailsProps) => {
  // const languages = getUILanguages(i18n.translation);
  // const controller = useTabs(languages.length);
  // const [tabs, setTabs] = useState(languages.map((x) => ({ title: x.display, value: x.value })));

  // useEffect(() => {
  //   setTabs(languages.map((x) => ({ title: x.display, value: x.value })));
  // }, [i18n.translation]);

  return <SystemForm patrolSystem={patrolSystem} isLoading={isLoading} isDisabled={disabled} onUpdate={onUpdate} />;

  // return <Tabs  tabs={tabs} contents={[panel]} />;
};

export default PatrolSystemDetails;
